module.exports = __webpack_public_path__ + "static/media/settings_border.28217a38.svg";